import { createContext, useContext } from 'react';
import { ICategories } from './interfaces';
import { CurrentPostQuery } from '@src/generated/graphql';
import { IPostNavigation } from '@src/pageHelpers/blog/handlePostNavigation';

type IPostContext = {
  post: CurrentPostQuery['allPost'][number];
  categories: ICategories;
  postNavigation: IPostNavigation;
};

const PostContext = createContext<IPostContext>({
  post: {},
  categories: [],
  postNavigation: { nextPost: null, prevPost: null },
});

export const PostProvider = PostContext.Provider;

export const usePostContext = (): IPostContext => useContext(PostContext);

export default PostContext;
